import { render } from "./Productividad.vue?vue&type=template&id=b207407e&scoped=true"
import script from "./Productividad.vue?vue&type=script&lang=js"
export * from "./Productividad.vue?vue&type=script&lang=js"

import "./Productividad.vue?vue&type=style&index=0&id=b207407e&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b207407e"]])

export default __exports__